/*
  nibec-brevo.js
  Manda una copia de los formularios de contacto y cotización a Brevo, a través del Worker
  de Cloudflare (infra/brevo-worker). El envío nativo de Shopify NO se toca: el correo a la
  tienda sigue llegando igual, y si Brevo o el Worker fallan no se pierde ninguna solicitud.

  Cada campo se lee por su `data-brevo`, nunca por su `name`: en el formulario de contacto
  el `name` sale de la etiqueta del customizer, y cambiar una etiqueta rompería el mapeo.

  La copia sale SOLO cuando Shopify aceptó el formulario. Antes salía al apretar "Enviar", y
  un envío que Shopify rechazaba (errores, desafío antispam) llegaba igual a Brevo: cada
  reintento de la persona era un ingreso más a la lista 12 (Sixteam vio 7 de un mismo
  contacto, 28-sep). Ahora el submit solo GUARDA los datos en sessionStorage, y se mandan
  cuando la página vuelve con el mensaje de éxito (`data-brevo-exito`, que el Liquid pinta
  únicamente con `form.posted_successfully?`). Se borran al mandarlos: recargar la página de
  éxito no manda otra copia.
*/

(() => {
  // Vacío = desactivado. Cuenta de Cloudflare de la agencia (ver infra/brevo-worker/README.md).
  // Subdominio propio y no *.workers.dev: los bloqueadores de anuncios cortan los envíos a
  // workers.dev (verificado 25-sep), pero no tocan el dominio de la tienda.
  const WORKER_URL = 'https://formularios.nibec.cl';
  const CLAVE = 'nibecBrevoPendiente';
  // Un envío pendiente más viejo que esto no es de la página de éxito que se está viendo.
  const VIGENCIA_MS = 30 * 60 * 1000;

  if (!WORKER_URL || window.nibecBrevoListo) return;
  window.nibecBrevoListo = true; // el snippet de cotización puede cargar el script varias veces

  const guardar = (valor) => {
    try {
      if (valor) sessionStorage.setItem(CLAVE, JSON.stringify(valor));
      else sessionStorage.removeItem(CLAVE);
    } catch {}
  };

  const leer = () => {
    try {
      return JSON.parse(sessionStorage.getItem(CLAVE) || 'null');
    } catch {
      return null;
    }
  };

  document.addEventListener('submit', (evento) => {
    const form = evento.target;
    const tipo = form.dataset && form.dataset.brevoForm;
    if (!tipo) return;

    // Trampa para bots del formulario de cotización (ver nibec-cotiza.js).
    const senuelo = form.querySelector('[name="nibec_hp"]');
    if (senuelo && senuelo.value.trim() !== '') return;

    const datos = { tipo };
    form.querySelectorAll('[data-brevo]').forEach((campo) => {
      datos[campo.dataset.brevo] = campo.value;
    });

    // Un reintento pisa al anterior: a Brevo llega solo el que Shopify termine aceptando.
    guardar({ datos, hora: Date.now() });
  });

  // El script va con defer: acá el DOM ya está completo.
  if (!document.querySelector('[data-brevo-exito]')) return;

  const pendiente = leer();
  guardar(null);
  if (!pendiente || !pendiente.datos || Date.now() - pendiente.hora > VIGENCIA_MS) return;

  const cuerpo = new Blob([JSON.stringify(pendiente.datos)], { type: 'text/plain' });
  // text/plain para que no haya preflight de CORS.
  if (!(navigator.sendBeacon && navigator.sendBeacon(WORKER_URL, cuerpo))) {
    fetch(WORKER_URL, { method: 'POST', body: cuerpo, keepalive: true, mode: 'cors' }).catch(() => {});
  }
})();
